// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"237":"a986cdfa","365":"3a6b74c6","488":"29b71886","497":"0d0206c7","511":"69002a5c","658":"3f467902"}[chunkId] + ".chunk.js";
};